//@flow
import React, { PureComponent } from "react";
import SelectField from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import Divider from "material-ui/Divider";
import { ListSubheader as Subheader } from "material-ui/List";
import Input, { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import Cookies from "js-cookie";
import IconButton from "material-ui/IconButton";
import ActionCompareArrows from "material-ui-icons/CompareArrows";

import Actions from './actions';

export default class LangSelection extends PureComponent<{ langs: ?Array<any>, originalLang: string, targetLang: string }> {
  state = {
  };

  componentDidMount() {

    Actions.loadLangsAction();
  }

  swap = () => {
    var tmp = this.props.originalLang;
    this.props.onChangeOriginal({ target: { value: this.props.targetLang } });
    this.props.onChangeTarget({ target: { value: tmp } });
  };

  render() {
    var oRecent = [];
    if (Cookies.get().oMRU) oRecent = JSON.parse(Cookies.get().oMRU);
    if (!oRecent instanceof Array || !oRecent.length) {
      oRecent = ["_detect"];
    }
    var tRecent = [];
    if (Cookies.get().tMRU) tRecent = JSON.parse(Cookies.get().tMRU);
    if (!tRecent instanceof Array || !tRecent.length) {
      tRecent = ["en"];
    }
      oRecent = oRecent.map(lang => this.props.langs.find(l => l.language === lang)).filter(x => x);
      tRecent = tRecent.map(lang => this.props.langs.find(l => l.language === lang)).filter(x => x);
      

    return (
      <div className="lang-selection">

        <FormControl>
          <InputLabel htmlFor="originalLang">Original Language</InputLabel>
          <SelectField
            MenuProps={{transitionDuration:10,className:'muisucks'}}
            input={<Input id="originalLang" />}
            value={this.props.originalLang}
            onChange={this.props.onChangeOriginal}
          >
            <Subheader>Recently used</Subheader>
            <MenuItem value="_detect" >Detect Language</MenuItem>
            {oRecent.map(l => (
              <MenuItem
                key={l.language}
                value={l.language}
                >{l.name}</MenuItem>
            ))}
            <Divider />
            <Subheader>All Languages</Subheader>
            {this.props.langs.map(l => (
              <MenuItem
              key={l.language}
              value={l.language}
              >{l.name}</MenuItem>
            ))}
          </SelectField>
          </FormControl>

        <FormControl>
          <InputLabel htmlFor="targetLang">Target Language</InputLabel>
          <SelectField
          MenuProps={{transitionDuration:10,className:'muisucks'}}
            input={<Input id="targetLang" />}
            value={this.props.targetLang}
            onChange={this.props.onChangeTarget}
          >
            <Subheader>Recently used</Subheader>
            <MenuItem value="_detect" >Detect Language</MenuItem>
            {tRecent.map(l => (
              <MenuItem
              key={l.language}
              value={l.language}
              >{l.name}</MenuItem>
            ))}
            <Divider />
            <Subheader>All Languages</Subheader>
            {this.props.langs.map(l => (
              <MenuItem
              key={l.language}
              value={l.language}
              >{l.name}</MenuItem>
            ))}
          </SelectField>
        </FormControl>
        <IconButton onClick={this.swap}>
          <ActionCompareArrows />
          </IconButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/LangSelection.js